define(["marionette", "./template/showTokenModalTemplate.html"], function (
  Marionette,
  ShowTokenModalTemplate,
) {
  "use strict";

  return {
    view: Marionette.ItemView.extend({
      className: "show-token-modal",
      template: ShowTokenModalTemplate,
      triggers: {
        "click #doneButton": "done",
      },
    }),
  };
});
